const primary = '#ea2a33';

export const Colors = {
  primary,
  light: {
    text: '#1e293b',
    textSecondary: '#64748b',
    background: '#f8f6f6',
    surface: '#ffffff',
    border: '#e2e8f0',
    tint: primary,
    icon: '#64748b',
    tabIconDefault: '#94a3b8',
    tabIconSelected: primary,
  },
  dark: {
    text: '#f1f5f9',
    textSecondary: '#94a3b8',
    background: '#211111',
    surface: '#2d1818',
    border: '#452626',
    tint: primary,
    icon: '#94a3b8',
    tabIconDefault: '#64748b',
    tabIconSelected: primary,
  },
  accent: {
    green: '#22c55e',
    amber: '#f59e0b',
    blue: '#3b82f6',
  },
};

export default Colors;
